'use client'

import { forwardRef, HTMLProps } from 'react'
import clsx from 'classnames'
import { useTranslations } from 'next-intl'
import { Text } from '@/shared/ui'
import { AnalyticsList } from '@/features/analytics-list'
import { RelevantPost } from '@/interfaces/analytics'
import style from './relevant-analytics.module.scss'

type RelevantAnalyticsProps = HTMLProps<HTMLDivElement> & {
  items: RelevantPost[]
}

export const RelevantAnalytics = forwardRef<HTMLElement, RelevantAnalyticsProps>((props, ref) => {
  const { className, items } = props
  const translate = useTranslations()
  return (
    <section className={clsx(style.container, 'main-padding', className)} ref={ref}>
      {items.length !== 0 && (
        <Text className={style.title} type="h2" color="dark">
          {translate('anotherPublication')}
        </Text>
      )}
      <AnalyticsList cards={items} publications />
    </section>
  )
})

RelevantAnalytics.displayName = 'RelevantAnalytics'
